export default ({store, redirect})=>{
  const isLoggedIn = store.getters['user/isLoggedIn'];
  if (!isLoggedIn) {
    return redirect('/authorization')
  }  
}